"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpMethod = void 0;
/**
 * Http methods enum.
 * Just for consistency.
 */
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["POST"] = "POST";
    HttpMethod["GET"] = "GET";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
